"use client";

import { useTheme } from "next-themes";
import React, { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";

/**
 * Theme-aware toaster that only applies dark/light styles after mount
 * to avoid SSR/client hydration mismatches from localStorage theme.
 */
export function AppToaster() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const isDark = mounted && resolvedTheme === "dark";

  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={12}
      containerClassName="!z-[2147483647]"
      containerStyle={{
        zIndex: 2147483647,
        position: "fixed"
      }}
      toastOptions={{
        className: isDark
          ? "!bg-gray-900 !text-white !border-gray-700 !shadow-xl !backdrop-blur-sm"
          : "!bg-white !text-gray-900 !border-gray-200 !shadow-xl !backdrop-blur-sm",
        style: {
          zIndex: 2147483647,
          position: "relative",
          borderRadius: "12px",
          padding: "16px 20px",
          fontSize: "14px",
          fontWeight: "500",
          maxWidth: "400px",
          border: isDark
            ? "1px solid rgb(55 65 81)"
            : "1px solid rgb(229 231 235)",
          boxShadow: isDark
            ? "0 25px 50px -12px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.05)"
            : "0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)"
        },
        success: {
          className: isDark
            ? "!bg-emerald-900/90 !text-emerald-100 !border-emerald-700"
            : "!bg-emerald-50 !text-emerald-800 !border-emerald-200",
          iconTheme: {
            primary: isDark ? "#10b981" : "#059669",
            secondary: isDark ? "#064e3b" : "#ecfdf5"
          }
        },
        error: {
          className: isDark
            ? "!bg-red-900/90 !text-red-100 !border-red-700"
            : "!bg-red-50 !text-red-800 !border-red-200",
          iconTheme: {
            primary: isDark ? "#ef4444" : "#dc2626",
            secondary: isDark ? "#7f1d1d" : "#fef2f2"
          }
        },
        loading: {
          duration: Infinity,
          className: isDark
            ? "!bg-blue-900/90 !text-blue-100 !border-blue-700"
            : "!bg-blue-50 !text-blue-800 !border-blue-200",
          iconTheme: {
            primary: isDark ? "#3b82f6" : "#2563eb",
            secondary: isDark ? "#1e3a8a" : "#eff6ff"
          }
        },
        position: "top-center",
        duration: 4000
      }}
    />
  );
}
